<template>

    <div class="w-100 h-100 tx-font bg-color-white tx-color-steel" style="min-width: 100vw;">
      <nav aria-label="Header">
        <v-toolbar height="50" class="hidden-sm-down tx-color-steel" color="#444444">
          <v-spacer></v-spacer>
          
          
          <ul class="navigation-list" role="list" aria-label="Header links">
            <li>
              <v-btn class="ma-2 text-none" prepend-icon="mdi-account-group-outline" @click="goTo('user-profile')" @keydown.enter="goTo('user-profile')" @keydown.space.prevent="goTo('user-profile')" aria-label="User Management" role="link" tabindex="0">
                <LanguagePlaceholder default-text="User Management" />
              </v-btn>
            </li>
            <li>
              <v-btn class="ma-2 text-none" prepend-icon="mdi-clipboard-account-outline"
                @click="systemStore.routerTo('contact-us')" @keydown.enter="systemStore.routerTo('contact-us')" @keydown.space.prevent="systemStore.routerTo('contact-us')" aria-label="Contact Us" role="link" tabindex="0">
                <LanguagePlaceholder default-text="Contact Us" />
              </v-btn>
            </li>
            <li>
              <v-btn class="ma-2 text-none" prepend-icon="mdi-help-circle-outline"
                @click="systemStore.routerTo('faq')" @keydown.enter="systemStore.routerTo('faq')" @keydown.space.prevent="systemStore.routerTo('faq')" aria-label="Help Center" role="link" tabindex="0">
                <LanguagePlaceholder default-text="Help Center" />
              </v-btn>
            </li>
            <li>
              <v-btn class="ma-2 text-none" prepend-icon="mdi-web" aria-label="Change language" aria-haspopup="menu" tabindex="0">
                <LanguagePlaceholder default-text="Languages" />
                <v-menu activator="parent" transition="scale-transition" location="bottom" aria-label="Language selection" :focus-trap="true">
                    <div aria-live="polite" aria-atomic="true" class="sr-only">{{ focusedLanguage }}</div>
                    <v-list role="menu" @keydown="handleLanguageMenuKeydown">
                        <v-list-item v-for="(item, index) in systemStore.getData('languages')" :key="index"
                            :value="index" @click="selectLanguage(item)" @keydown.enter="selectLanguage(item)" @keydown.space.prevent="selectLanguage(item)" @focus="announceFocusedLanguage(item)" role="menuitem" tabindex="-1" :aria-label="item.language">
                            <v-list-item-title>
                                <LanguagePlaceholder :default-text="item.language" />
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
              </v-btn>
            </li>
            <li v-if="systemStore.userDetail.userType.trim() === 'TIC_Admin' && systemStore.userDetail.affinityId === 987654321">
              <v-btn class="ma-2 text-none" prepend-icon="mdi-view-dashboard-outline" @click="systemStore.routerTo('admin')" @keydown.enter="systemStore.routerTo('admin')" @keydown.space.prevent="systemStore.routerTo('admin')" aria-label="Admin Dashboard" role="link" tabindex="0">
                <LanguagePlaceholder default-text="Admin" />
              </v-btn>
            </li>
            <li>
              <v-btn class="ma-2 text-none" prepend-icon="mdi-logout-variant" @click="logout" @keydown.enter="logout" @keydown.space.prevent="logout" aria-label="Log Out" role="link" tabindex="0">
                <LanguagePlaceholder default-text="Log Out" />
              </v-btn>
            </li>
          </ul>
          
          <v-spacer></v-spacer>
        </v-toolbar>
      </nav>

      <div class="d-flex justify-center w-100 TopLogos" role="banner" aria-label="Partner logos and user information">
        <div class="d-flex justify-center w-50">
          <ul class="d-flex align-center ma-0 pa-0" aria-label="Technology partner logos" style="list-style: none;">
            <li>
              <v-img
                :width="200"
                aspect-ratio="16/9"
                src="https://dellpartnerincentives.com/siteassets/Images/Global/logoDell.png"
                alt="Dell Technologies Logo"
              ></v-img>
            </li>
            <li>
              <v-img
                :width="150"
                aspect-ratio="16/9"
                src="https://dellpartnerincentives.com/siteassets/Images/Global/logoAmd.png"
                alt="AMD Logo"
              ></v-img>
            </li>
            <li>
              <v-img
                :width="200"
                aspect-ratio="16/9"
                src="https://dellpartnerincentives.com/siteassets/Images/Global/logoWindows11.png"
                alt="Windows 11 Logo"
              ></v-img>
            </li>
            <li>
              <v-img
                :width="200"
                aspect-ratio="16/9"
                src="https://dellpartnerincentives.com/siteassets/Images/Global/logoIntel.png"
                alt="Intel Logo"
              ></v-img>
            </li>
            <li>
              <v-img
                :width="200"
                aspect-ratio="16/9"       
                src="https://dellpartnerincentives.com/siteassets/Images/Global/logoMicrosoft.png"
                alt="Microsoft Logo"
              ></v-img>
            </li>
          </ul>
          <SpecialButton 
            class="hidden-sm-down ms-14 tx-color-carbon"
            icon-color="#0672CB"
            icon="mdi-account-outline"
            :icon-size="40"
            :button-width="200" :title="systemStore.userDetail.fullname"
            :sub-title="systemStore.userDetail.userType == 'Partner' ? 'Authorized Reseller' : systemStore.userDetail.userType"
            @click="goTo('user-profile')"
            tabindex="0"
            @keydown.enter="goTo('user-profile')" 
            @keydown.space.prevent="goTo('user-profile')"
            role="link"
            :aria-label="`User profile for ${systemStore.userDetail.fullname}, ${systemStore.userDetail.userType == 'Partner' ? 'Authorized Reseller' : systemStore.userDetail.userType}`"/>
          <SpecialButton v-if="systemStore.userDetail.userType == 'Partner'"
            class="ms-5 tx-color-carbon"
            icon-color="#0672CB"
            icon="mdi-currency-usd"
            :icon-size="40"
            :button-width="320"
            title="Rewards this Incentive Period: $0.00"
            sub-title="" :isSelectable="false" 
            aria-label="Rewards this Incentive Period: $0.00" />
        </div>    
      </div>    
  
      <nav aria-label="Main menu">
        <div fluid class="pa-0">
          <v-card variant="flat" tile class="my-5 py-3 bg-color-quartz tx-color-steel hidden-sm-down">
            <v-row justify="center">
              <!-- WCAG 2.1.1 ARIA menubar: arrow key navigation per https://www.w3.org/WAI/ARIA/apg/patterns/menubar/ -->
              <ul class="navigation-list" role="menubar" aria-label="Primary navigation menu" @keydown="handleMenubarKeydown">
                <li v-for="o, idx in menuOptions" :key="idx" role="none">
                  <v-btn size="small" variant="text" class="text-none" color="#444444" stacked
                      :prepend-icon="o.icon"
                      @click="systemStore.routerTo(o.routerPath)"
                      @keydown.enter="systemStore.routerTo(o.routerPath)"
                      @keydown.space.prevent="systemStore.routerTo(o.routerPath)"
                      :aria-label="o.text"
                      :aria-haspopup="o.subOptions && o.subOptions.length > 0 ? 'menu' : undefined"
                      role="menuitem"
                      :tabindex="idx === 0 ? 0 : -1"
                      :data-menubar-idx="idx">
                      <LanguagePlaceholder is-html :default-text="o.text" />
                      <v-menu v-if="o.subOptions !== undefined && o.subOptions.length > 0" activator="parent"
                          transition="scale-transition" location="bottom" :aria-label="o.text + ' submenu'">
                          <v-list role="menu" @keydown="handleSubmenuKeydown">
                              <v-list-item v-for="(m, midx) in o.subOptions" :key="midx"
                                  @click="systemStore.routerTo(m.routerPath)"
                                  @keydown.enter="systemStore.routerTo(m.routerPath)"
                                  @keydown.space.prevent="systemStore.routerTo(m.routerPath)"
                                  role="menuitem" tabindex="-1" :aria-label="m.title">
                                  <v-list-item-title>
                                      <LanguagePlaceholder :default-text="m.title" />
                                  </v-list-item-title>
                              </v-list-item>
                          </v-list>
                      </v-menu>
                  </v-btn>
                </li>
              </ul>
            </v-row>
          </v-card>
        </div>
      </nav>
  
      <main aria-label="Page content">
        <router-view v-slot="{ Component, route }">
          <transition name="router-anim">
              <component :is="Component" :key="route.path" />
          </transition>
        </router-view>
      </main>
  
      <v-footer height="80" class="hidden-sm-down" color="#444444" role="contentinfo">
        <v-row justify="center" no-gutters>
          <ul class="navigation-list" role="list" aria-label="Footer links">
            <li>
              <v-btn class="ma-2 text-none" variant="text" @click="systemStore.routerTo('terms-of-use')" @keydown.enter="systemStore.routerTo('terms-of-use')" @keydown.space.prevent="systemStore.routerTo('terms-of-use')" aria-label="Terms Of Use" tabindex="0" role="link">
                <LanguagePlaceholder is-html position="fixed"
                    default-text="Terms Of Use" />
              </v-btn>
            </li>
            <li>
              <v-btn class="ma-2 text-none" variant="text" @click="systemStore.routerTo('privacy-statement')" @keydown.enter="systemStore.routerTo('privacy-statement')" @keydown.space.prevent="systemStore.routerTo('privacy-statement')" aria-label="Privacy Statement" tabindex="0" role="link">
                <LanguagePlaceholder is-html position="fixed"
                    default-text="Privacy Statement" />
              </v-btn>
            </li>
            <li>
              <v-btn class="ma-2 text-none" variant="text" @click="systemStore.routerTo('cookies-information')" @keydown.enter="systemStore.routerTo('cookies-information')" @keydown.space.prevent="systemStore.routerTo('cookies-information')" aria-label="Cookies Information" tabindex="0" role="link">
                <LanguagePlaceholder is-html position="fixed"
                    default-text="Cookies Information" />
              </v-btn>
            </li>
          </ul>
        </v-row>
      </v-footer>
  
    </div>

</template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import router from '../router'
  import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
  import { useSystemStore } from '@/stores/system'
  import { useAuthStore } from '@/stores/auth'
  import SpecialButton from '@/components/SpecialButton.vue'
  
  const authStore = useAuthStore()
  const systemStore = useSystemStore()
  const showBottomSheet = ref(false)
const focusedLanguage = ref('')

const announceFocusedLanguage = (item) => {
    focusedLanguage.value = item.language
}

const handleMenubarKeydown = (e) => {
    const menubar = e.currentTarget
    const items = Array.from(menubar.querySelectorAll('[role="menuitem"]')).filter(el => el.closest('[role="menubar"]') === menubar)
    if (!items.length) return
    const currentIndex = items.indexOf(document.activeElement)

    if (e.key === 'ArrowRight') {
        e.preventDefault()
        const next = items[currentIndex < items.length - 1 ? currentIndex + 1 : 0]
        if (next) { next.tabIndex = 0; items.forEach((el, i) => { if (el !== next) el.tabIndex = -1 }); next.focus() }
    } else if (e.key === 'ArrowLeft') {
        e.preventDefault()
        const prev = items[currentIndex > 0 ? currentIndex - 1 : items.length - 1]
        if (prev) { prev.tabIndex = 0; items.forEach((el, i) => { if (el !== prev) el.tabIndex = -1 }); prev.focus() }
    } else if (e.key === 'Home') {
        e.preventDefault()
        if (items[0]) { items[0].tabIndex = 0; items.forEach((el, i) => { if (i > 0) el.tabIndex = -1 }); items[0].focus() }
    } else if (e.key === 'End') {
        e.preventDefault()
        const last = items[items.length - 1]
        if (last) { last.tabIndex = 0; items.forEach((el, i) => { if (el !== last) el.tabIndex = -1 }); last.focus() }
    }
}

const handleSubmenuKeydown = (e) => {
    const list = e.currentTarget
    const items = Array.from(list.querySelectorAll('[role="menuitem"]'))
    if (!items.length) return
    const currentIndex = items.indexOf(document.activeElement)

    if (e.key === 'ArrowDown') {
        e.preventDefault()
        items[currentIndex < items.length - 1 ? currentIndex + 1 : 0]?.focus()
    } else if (e.key === 'ArrowUp') {
        e.preventDefault()
        items[currentIndex > 0 ? currentIndex - 1 : items.length - 1]?.focus()
    } else if (e.key === 'Home') {
        e.preventDefault()
        items[0]?.focus()
    } else if (e.key === 'End') {
        e.preventDefault()
        items[items.length - 1]?.focus()
    } else if (e.key === 'Escape') {
        e.preventDefault()
        list.closest('[aria-haspopup="menu"]')?.focus?.()
    }
}

const handleLanguageMenuKeydown = (e) => {
    const list = e.currentTarget
    const items = Array.from(list.querySelectorAll('[role="menuitem"]'))
    if (!items.length) return
    const currentIndex = items.indexOf(document.activeElement)

    if (e.key === 'ArrowDown') {
        e.preventDefault()
        const next = items[currentIndex < items.length - 1 ? currentIndex + 1 : 0]
        next?.focus()
    } else if (e.key === 'ArrowUp') {
        e.preventDefault()
        const prev = items[currentIndex > 0 ? currentIndex - 1 : items.length - 1]
        prev?.focus()
    } else if (e.key === 'Home') {
        e.preventDefault()
        items[0]?.focus()
    } else if (e.key === 'End') {
        e.preventDefault()
        items[items.length - 1]?.focus()
    } else if (e.key === 'Escape') {
        e.preventDefault()
        list.closest('[role="menu"]')?.previousElementSibling?.focus?.()
    }
}
  
  const menuOptions = ref([])
  const sideOptions = ref([])
  
  const configMenuOptions = () => {
      menuOptions.value = []
  
      let reportsSubOptions = [];
  
      const dellInternalReportAccess = ['TIC_Admin', 'TP', 'PAM', 'Dell Marketing']   
      const hasDellInternalReportAccess = dellInternalReportAccess.indexOf(systemStore.userDetail.userType.trim()) > -1 ? true : false
      
      if (hasDellInternalReportAccess) {
          reportsSubOptions.push({ title: 'Dell Internal', routerPath: 'dell-internal-reports' });
      }
  
      reportsSubOptions.push(
          { title: 'Distributor Dashboard', routerPath: 'distributor-dashboard' },
          { title: 'Partner Performance', routerPath: 'partner-performance' },
          // { title: 'Redemption Balance Report', routerPath: 'distributor-redemption' },
          { title: 'Redemption Balance Report', routerPath: 'distributor-redemption-banked' },
          { title: 'Distributor E-Voucher Report', routerPath: 'distributor-evoucher-report' },
          { title: 'Credit Note Report', routerPath: 'creditnote-report' },
          { title: 'Bonus Dashboard Partner', routerPath: 'bonus-dashboard-partner' },
          { title: 'Bonus Dashboard Distributor', routerPath: 'bonus-dashboard-distributor' },
          { title: 'Distributor Referral Report', routerPath: 'distributor-referral-report' },
      )
  
      if (systemStore.userDetail.userType.trim() === 'Partner') {
          menuOptions.value.push({ text: 'Home', toolbar: 'primary', icon: 'mdi-home-outline', routerPath: 'home-partner' })
          menuOptions.value.push({ text: 'About RISE', toolbar: 'primary', icon: 'mdi-information-outline', routerPath: 'home-about-rise-partner' })
          // menuOptions.value.push({
          //     text: 'Redemption', toolbar: 'primary', icon: 'mdi-clipboard-list-outline', subOptions: [
          //         { title: 'Redeem My Rewards', routerPath: 'redemption' },
          //         { title: 'Redemption Summary', routerPath: 'redemption-summary' },
        //     ]
          // })
          menuOptions.value.push({ text: 'Rewards Center', toolbar: 'primary', icon: 'mdi-clipboard-list-outline', routerPath: 'redemption' })
          menuOptions.value.push({ text: 'Peripheral Promotions', toolbar: 'primary', icon: 'mdi-mouse-outline', routerPath: 'dncp' })
          menuOptions.value.push({ text: 'Eligible Products', toolbar: 'primary', icon: 'mdi-tag-outline', routerPath: 'home-eligible-products' })
          menuOptions.value.push({ text: 'Rewards Paid', toolbar: 'primary', icon: 'mdi-currency-usd', routerPath: 'partner-rewards-paid' })
          menuOptions.value.push({ text: 'My Performance', toolbar: 'primary', icon: 'mdi-finance', routerPath: 'my-performance' })
          menuOptions.value.push({ text: 'My Bonus Dashboard', toolbar: 'primary', icon: 'mdi-view-dashboard-outline', routerPath: 'bonus-dashboard-partner' })
          menuOptions.value.push({ text: 'Rewards Calculator', toolbar: 'primary', icon: 'mdi-calculator', routerPath: 'rewards-calculator' })
          menuOptions.value.push({ text: 'RISE Opportunities', toolbar: 'primary', icon: 'mdi-gift-outline', routerPath: 'rise-opportunities' })
          // menuOptions.value.push({ text: 'News', toolbar: 'primary', icon: 'mdi-wifi', routerPath: 'news' }) // uncomment later
      } else if (systemStore.userDetail.userType.trim() === 'Distributor') {
          menuOptions.value.push({ text: 'Home', toolbar: 'primary', icon: 'mdi-home-outline', routerPath: 'home-distributor' })
          menuOptions.value.push({ text: 'About RISE', toolbar: 'primary', icon: 'mdi-information-outline', routerPath: 'home-about-rise-distributor' })
          menuOptions.value.push({ text: 'Eligible Products', toolbar: 'primary', icon: 'mdi-tag-outline', routerPath: 'home-eligible-products' })
          menuOptions.value.push({ text: 'Rewards Calculator', toolbar: 'primary', icon: 'mdi-calculator', routerPath: 'rewards-calculator-disti' })
          menuOptions.value.push({ text: 'Marketing Assets', toolbar: 'primary', icon: 'mdi-arrow-collapse-down', routerPath: 'marketing-assets' })
          menuOptions.value.push({ text: 'RISE Opportunities', toolbar: 'primary', icon: 'mdi-gift-outline', routerPath: 'rise-opportunities' })
          menuOptions.value.push({
              text: 'Reports', toolbar: 'primary', icon: 'mdi-chart-box-multiple-outline', subOptions: [
                  // { title: 'Distributor Dashboard', routerPath: 'distributor-dashboard' },
                  { title: 'Partner Performance', routerPath: 'partner-performance' },
                // { title: 'Redemption Balance Report', routerPath: 'distributor-redemption' },
                { title: 'Redemption Balance Report', routerPath: 'distributor-redemption-banked' },
                { title: 'E-Voucher Report', routerPath: 'distributor-evoucher-report' },
                  { title: 'Credit Note Report', routerPath: 'creditnote-report' },
                  { title: 'Bonus Dashboard Distributor', routerPath: 'bonus-dashboard-distributor' },
                  { title: 'Distributor Referral Report', routerPath: 'distributor-referral-report' },
              ]
          })
          // menuOptions.value.push({ text: 'News', toolbar: 'primary', icon: 'mdi-wifi', routerPath: 'news' }) // uncomment later
  
      } else if (systemStore.userDetail.userType.trim() === 'Dell'
          || systemStore.userDetail.userType.trim() === 'TP'
          || systemStore.userDetail.userType.trim() === 'PAM'
          || systemStore.userDetail.userType.trim() === 'Dell Marketing'
          || systemStore.userDetail.userType.trim() === 'TIC_Admin'
      ) {
          menuOptions.value.push({ text: 'Home Partner', toolbar: 'primary', icon: 'mdi-home-outline', routerPath: 'home-partner' })
          menuOptions.value.push({ text: 'Home Distributor', toolbar: 'primary', icon: 'mdi-home-outline', routerPath: 'home-distributor' })
          menuOptions.value.push({ text: 'About RISE Partner', toolbar: 'primary', icon: 'mdi-information-outline', routerPath: 'home-about-rise-partner' })
          menuOptions.value.push({ text: 'About RISE Distributor', toolbar: 'primary', icon: 'mdi-information-outline', routerPath: 'home-about-rise-distributor' })        
          // menuOptions.value.push({
          //     text: 'Redemption', toolbar: 'primary', icon: 'mdi-clipboard-list-outline', subOptions: [
          //         { title: 'Redeem My Rewards', routerPath: 'redemption' },
          //         { title: 'Redemption Summary', routerPath: 'redemption-summary' },
          //     ]
          // })
          menuOptions.value.push({ text: 'Rewards Center', toolbar: 'primary', icon: 'mdi-clipboard-list-outline', routerPath: 'redemption' })
          menuOptions.value.push({ text: 'Peripheral Promotions', toolbar: 'primary', icon: 'mdi-mouse-outline', routerPath: 'dncp' })
          menuOptions.value.push({ text: 'Eligible Products', toolbar: 'primary', icon: 'mdi-tag-outline', routerPath: 'home-eligible-products' })
          menuOptions.value.push({ text: 'Rewards Paid', toolbar: 'primary', icon: 'mdi-currency-usd', routerPath: 'partner-rewards-paid' })
          menuOptions.value.push({ text: 'My Performance', toolbar: 'primary', icon: 'mdi-finance', routerPath: 'my-performance' })
          menuOptions.value.push({ text: 'Rewards Calculator', toolbar: 'primary', icon: 'mdi-calculator', routerPath: 'rewards-calculator' })
          menuOptions.value.push({ text: 'Marketing Assets', toolbar: 'primary', icon: 'mdi-arrow-collapse-down', routerPath: 'marketing-assets' })
          menuOptions.value.push({ text: 'RISE Opportunities', toolbar: 'primary', icon: 'mdi-gift-outline', routerPath: 'rise-opportunities' })
          menuOptions.value.push({ text: 'Reports', toolbar: 'primary', icon: 'mdi-chart-box-multiple-outline', subOptions: reportsSubOptions })
          // menuOptions.value.push({ text: 'News', toolbar: 'primary', icon: 'mdi-wifi', routerPath: 'news' }) // uncomment later
      }
  
      sideOptions.value = [...menuOptions.value]
  
      if (hasDellInternalReportAccess) {
          reportsSubOptions.push({ title: 'Google Analytics', routerPath: 'google-analytics' });
      }
  
      sideOptions.value.push({ text: 'User Management', toolbar: 'primary', icon: 'mdi-account-group-outline', routerPath: 'user-profile' })
      sideOptions.value.push({ text: 'My Messages', toolbar: 'primary', icon: 'mdi-email-outline', routerPath: 'messages' })
      sideOptions.value.push({ text: 'Contact Us', toolbar: 'primary', icon: 'mdi-clipboard-account-outline', routerPath: 'contact-us' })
      sideOptions.value.push({ text: 'Help Center', toolbar: 'primary', icon: 'mdi-help-circle-outline', routerPath: 'faq' })
      sideOptions.value.push({ text: 'Languages', toolbar: 'primary', icon: 'mdi-web' })
  
      sideOptions.value.push({ text: 'Log Out', toolbar: 'primary', icon: 'mdi-logout-variant-outline', routerPath: 'logout' })
      
      sideOptions.value.push({ text: 'Terms Of Use', toolbar: 'primary', icon: '', routerPath: 'terms-of-use' })
      sideOptions.value.push({ text: 'Privacy Statement', toolbar: 'primary', icon: '', routerPath: 'privacy-statement' })
      sideOptions.value.push({ text: 'Cookies Information', toolbar: 'primary', icon: '', routerPath: 'cookies-information' })
  
  }
  
  onMounted(() => {
      configMenuOptions()
  
      // query('set', 'user_properties', {
      //     affinity_id: systemStore.userDetail.affinityId,
      //     user_type: systemStore.userDetail.userType,
      // })
  })
  
  const selectLanguage = (item) => {
      showBottomSheet.value = false
  
      systemStore.selectedLanguage = item.iso.toLowerCase()
  
      systemStore.updateUserLanguage(0, systemStore.selectedLanguage).then(() => {
          systemStore.showMessage('User default language updated (' + systemStore.selectedLanguage.toUpperCase() + ')', { color: 'success' })
          localStorage.setItem("selectedLanguage", systemStore.selectedLanguage)
      })
  }
  
  const goTo = (routeName) => {
      if (routeName !== undefined) {
          router.push({ name: routeName })
          showBottomSheet.value = false
      }
  }
  
  const logout = () => {
      authStore.logout()
  }
  
  </script>
  
  <style scoped>
  
    .TopLogos{
      background-color:#eeeeee;
      color:#6e6e6e;
      padding:20px 0px;
      flex-wrap: wrap;
    }

    /* WCAG 1.4.10 Reflow — content must be usable at 320px / 400% zoom */
    @media (max-width: 960px) {
      .TopLogos > div {
        width: 100% !important;
        flex-wrap: wrap;
        justify-content: center;
      }
      .TopLogos ul {
        flex-wrap: wrap;
        justify-content: center;
      }
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    /* Navigation list styling for accessibility - removes default list styling while maintaining semantic structure */
    .navigation-list {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
    }

    .navigation-list li {
      display: inline-block;
      margin: 0;
      padding: 0;
    }

    /*
      WCAG 2.0 Focus Indicators — dual-ring pattern:
        outer ring : #003785 dark navy (~13:1 vs white, ~4:1 vs quartz)
        inner halo : #FFFFFF white   (~8:1 vs dark toolbar/footer #444444)
      Visible on both the light main-nav background and the dark #444444 toolbar/footer.
    */
    :deep(.v-btn:focus-visible) {
      outline: 3px solid #003785 !important;
      outline-offset: 4px !important;
      box-shadow: 0 0 0 4px #FFFFFF !important;
      position: relative !important;
      z-index: 10 !important;
    }

    :deep(.v-list-item:focus-visible) {
      outline: 3px solid #003785 !important;
      outline-offset: 2px !important;
      box-shadow: 0 0 0 2px #FFFFFF !important;
      background-color: rgba(0, 55, 133, 0.08) !important;
    }

    /* High contrast mode support */
    @media (prefers-contrast: high) {
      :deep(.v-btn:focus-visible),
      :deep(.v-list-item:focus-visible) {
        outline-width: 4px !important;
        outline-color: #000000 !important;
        box-shadow: 0 0 0 4px #FFFFFF !important;
      }
    }

    /* Reduced motion support for transitions */
    @media (prefers-reduced-motion: reduce) {
      .router-anim-enter-active,
      .router-anim-leave-active {
        animation: none !important;
        transition: opacity 0.1s ease-in-out !important;
      }
    }

    /* WCAG 2.0 Color Contrast Improvements */
    .tx-color-steel {
      color: #2C2C2C !important; /* Darker steel for better contrast */
    }

    /* Ensure proper contrast for toolbar text - lighter color for better visibility */
    .v-toolbar.tx-color-steel {
      color: #FFFFFF !important; /* White text for better contrast on dark toolbar */
    }

    /* Ensure toolbar buttons have proper contrast */
    .v-toolbar .v-btn {
      color: #FFFFFF !important;
    }

    /* Ensure proper contrast for footer text */
    .v-footer {
      color: #FFFFFF !important;
    }

    /* High contrast mode support for text colors */
    @media (prefers-contrast: high) {
      .tx-color-steel {
        color: #000000 !important;
      }
      
      .v-toolbar.tx-color-steel {
        color: #FFFFFF !important; /* Keep white for high contrast on dark toolbar */
      }
      
      .v-toolbar .v-btn {
        color: #FFFFFF !important;
      }
    }

    /* WCAG 1.4.10 Reflow / 1.4.4 Resize Text — toolbar and nav stay usable at 200%+ zoom.
       Override hidden-sm-down so header toolbar and nav scroll rather than disappearing.
       Scrollbar hidden visually (scrollbar-width/overflow styling) but still functional. */
    .v-toolbar.hidden-sm-down {
      display: flex !important;
      overflow-x: auto;
      overflow-y: visible;
      min-width: 100%;
      width: 100%;
      flex-wrap: nowrap;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE/Edge */
    }

    .v-toolbar.hidden-sm-down::-webkit-scrollbar {
      display: none; /* Chrome/Safari/Opera */
    }

    .v-toolbar.hidden-sm-down :deep(.v-toolbar__content) {
      overflow-x: auto;
      overflow-y: visible;
      min-width: min-content;
      flex-wrap: nowrap;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }

    .v-toolbar.hidden-sm-down :deep(.v-toolbar__content)::-webkit-scrollbar {
      display: none;
    }

    .v-toolbar.hidden-sm-down .v-btn {
      flex-shrink: 0;
      white-space: nowrap;
    }

    /* Keep main nav visible and scrollable at high zoom levels — no visible scrollbar */
    .v-card.hidden-sm-down {
      display: block !important;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }

    .v-card.hidden-sm-down::-webkit-scrollbar {
      display: none;
    }

    .v-card.hidden-sm-down :deep(.v-card__loader),
    .v-card.hidden-sm-down ul {
      flex-wrap: nowrap;
      overflow-x: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }

    .v-card.hidden-sm-down ul::-webkit-scrollbar {
      display: none;
    }

    /* Prevent TopLogos overflow at 320px */
    @media (max-width: 599px) {
      .TopLogos {
        overflow-x: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;
      }
      .TopLogos::-webkit-scrollbar {
        display: none;
      }
      .TopLogos :deep(.v-img) {
        max-width: 120px !important;
        min-width: 80px !important;
      }
    }
  
  </style>